import React, { useState, useCallback, useEffect, useRef, useTransition } from 'react';
import useChatStore from './useChatStore';
import './OuterChatbox.css';
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import SendSharpIcon from '@mui/icons-material/SendSharp';
import axios from "../../API/axios";
import DoneAllSharpIcon from '@mui/icons-material/DoneAllSharp';
import moment from 'moment';
import MoreHorizSharpIcon from '@mui/icons-material/MoreHorizSharp';
import DropDownBox from './DropDownBox';
import ThemedEmojiPicker from "../../components/ThemedEmojiPicker";
import AddReactionSharpIcon from "@mui/icons-material/AddReactionSharp";
import { useTranslation } from "react-i18next";
import { Tooltip } from "@mui/material";


const ChatBox = ({ user }) => {
    console.log('user in chatbox:', user);
    const { t } = useTranslation();
    const currentUserProfilPic = localStorage.getItem("profilPic");
    const sessionId = localStorage.getItem("sessionId");
    const [showDropdown, setShowDropdown] = useState(false);
    const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
    const [selectedMessageId, setSelectedMessageId] = useState(null);
    const { removeChat, toggleChat, updateInput, updateMessages, storeMessages, setMessageID, setMsgIDDirect, getMessageList } = useChatStore();
  const [content, setContent] = useState("");
  const[messageId,setMessageId]=useState(null);
      const language = localStorage.getItem("Lang");


    const footerRef = useRef();

 const InitiateMessage = useCallback(async () => {
        const messageDetails = {
            deviceType: "Web",
            sessionId: sessionId,
            type: 1,
            msg: user.inputValue,
            toUserUid: user.userUid,
            langKey: language === "en" ? "" : language,
        };

        try {
            await axios
                .post("Message/InitiateMessage", messageDetails)
                .then((response) => {
                    updateInput(user.userUid, "");
                    getChatList();
                    getMessageList();
                    setMsgIDDirect(user.userUid, response.data.responseData.id);
                });

        } catch (error) {
            console.log(error);
        }
    }, [user.userUid, user.messages, user.inputValue]);
console.log('messageId',messageId);
 const ReplyMessage = useCallback(async () => {
        const messageDetails = {
            deviceType: "Web",
            sessionId: sessionId,
            // msgID: user.msgID,
            msgID: messageId,
            type: 1,
            msg: user.inputValue,
            langKey: language === "en" ? "" : language,

        };
        try {
            await axios
                .post("Message/ReplyMessage", messageDetails)
                .then((response) => {
                    if (response.status == 200 && response.data.status === "Success") {
                        updateInput(user.userUid, "");
                        getChatList();
                    }
                    console.log("response", response);
                });

        } catch (error) {
            console.log(error);
        }
    }, [user.userUid, user.messages, user.inputValue]);

    const sendMessageHandler = useCallback(() => {
        try {
            if (user.inputValue.length) {
                if (!user.messages.length) {
                    InitiateMessage();
                } else {
                    ReplyMessage();
                }
            }
        } catch (error) {
            console.log(error);
        }
    }, [user.inputValue,user.messages, InitiateMessage, ReplyMessage])


    const getChatList = useCallback(async () => {
        const data = {
            deviceType: "Web",
            sessionId: sessionId,
            toUserUid: user.userUid,
        };
        axios
            .post(`Message/GetUserChat`, data)
            .then((response) => {
                console.log("Get User ChatList",response);
                // toggleChat(user.userUid);
                const res = response.data.responseData.chatList;
                storeMessages(user.userUid, res);
                setMessageId(response.data.responseData.messageInfo.msgID)
            })
            .catch((error) => {
                console.log(error);
            });
    }, [user.userUid, user.messages, user.inputValue]);

   

   

    useEffect(() => {
        getChatList();
        setMessageID(user.userUid);
    }, [user.userUid]);

    useEffect(() => {
        if (footerRef.current && user.isOpen) {
            footerRef.current.scrollIntoView({ behavior: "smooth", block: "end" });
        }
    }, [user.messages, user.isOpen]);

    const inputChangeHandler = useCallback((userId, value) => {
        try {
            updateInput(userId, value);
        } catch (error) {
            console.log(error);
        }
    }, [user.inputValue]);


    const handleMoreOptions = (event, record) => {
        try {
            event.stopPropagation(); // Prevent unwanted bubbling

            // const rect = event.currentTarget.getBoundingClientRect();
            // setDropdownPosition({
            //     top: rect.top,
            //     left: record.isOwned ? rect.left : rect.right + 220, // Align left for sent messages, right for received
            // });
            setShowDropdown(true);
            setSelectedMessageId(prevId => (prevId === record.chatID ? null : record.chatID));
        } catch (error) {
            console.log(error);
        }
    }

      //************************Emoji piker  Start  ************************//
     
      const [showEmojiPicker, setShowEmojiPicker] = useState(false);
      const handleEmojiClick = () => {
        setShowEmojiPicker(!showEmojiPicker);
      };
      const handleEmojiClose = () => {
        setShowEmojiPicker(false);
      };

        const getDisplayDate = (date) => {
                const today = moment().startOf("day");
                const msgDate = moment(date).startOf("day");

                if (msgDate.isSame(today, "day")) {
                        return "Today";
                } else if (msgDate.isSame(today.clone().subtract(1, "day"), "day")) {
                        return "Yesterday";
                } else if (msgDate.isAfter(today.clone().subtract(6, "day"))) {
                        return msgDate.format("dddd");
                } else {
                        return msgDate.format("DD-MM-YYYY");
                }
        };

    return (
        <div className={`chat-box ${user.isOpen ? 'open' : 'closed'}`}>
            <div className="chat-header" onClick={() => toggleChat(user.userUid)}>
                <div className='outer-chat-box-header-img-fullname'>
                    <a href={`/User/${user.userUid}`} target='_blank'>
                    <img src={user.profilPic} alt="" width={35} height={35} style={{ borderRadius: "50px" }} />
                    </a>
                    {/* <a href={`/User/${user.userUid}`} target='_blank'> */}
                    <span className='outer-chat-box-username'   title={user.fullName}>
                        {user.fullName}
                        </span>
                        {/* </a> */}
                </div>
                <CloseSharpIcon 
                // onClick={() => removeChat(user.userUid)}
                onClick={(e) => {
                  e.stopPropagation(); 
                  removeChat(user.userUid);
  }}
                 />
            </div>

            
            {
                user.isOpen && (
                    <div className="chat-messages">
                        {user.messages.map((record, index) => {
                            const previousRecord = user.messages[index - 1];
                            const showDateDivider =
                                index === 0 ||
                                !moment(record.time).isSame(moment(previousRecord?.time), "day");

                            return (
                            <React.Fragment key={record.chatID || index}>
                                {showDateDivider && (
                                    <div className="text-center my-3">
                                        <Tooltip
                                            title={
                                                <p className="text-light">
                                                    {moment.utc(record.time).local().format("DD MMMM YYYY")}
                                                </p>
                                            }
                                            arrow
                                        >
                                            <span className="chat-date-divider px-3 py-1 rounded  f-10 f-500">
                                                {getDisplayDate(record.time)}
                                            </span>
                                        </Tooltip>
                                    </div>
                                )}

                            <div
                                className={`message-container ${record.isOwned ? "owned" : "received"}`}
                                ref={footerRef}
                            >
                                {/* Layout for Received Messages */}
                                {/* {!record.isOwned && !record.isDeleted && ( */}
                                {!record.isOwned && (!record.isDeleted || record.isCompleteDeleted === true) && (

                                    <>
                                        <img
                                            src={user.profilPic}
                                            alt="Profile"
                                            className="message-avatar"
                                        />
                                        <div className="message-bubble f-10 f-400">{record.msg}
                                            <div className="message-time">
                                                {moment.utc(record.time).local().format("LT")}
                                            </div>
                                        </div>
                                        <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                                            {
                                                selectedMessageId === record.chatID && <DropDownBox
                                                    visible={showDropdown}
                                                    setVisibility={setShowDropdown}
                                                    record={record}
                                                // style={{
                                                //     position: "absolute",
                                                //     top: `${dropdownPosition.top}px`,
                                                //     left: `${dropdownPosition.left}px`,
                                                //     transform: "translateY(-50%)",
                                                //     zIndex: 1000
                                                // }}
                                                />
                                            }
                                            <MoreHorizSharpIcon className="material-symbols-sharp" onClick={(e) => handleMoreOptions(e, record)} />
                                        </div>
                                    </>
                                )}

                                {/* Layout for Sent Messages */}
                                {record.isOwned && !record.isDeleted && (
                                    <>
                                        <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                                            {
                                                selectedMessageId === record.chatID && <DropDownBox
                                                    visible={showDropdown}
                                                    setVisibility={setShowDropdown}
                                                    record={record}
                                                // style={{
                                                //     position: "absolute",
                                                //     top: `${dropdownPosition.top}px`,
                                                //     left: `${dropdownPosition.left}px`,
                                                //     transform: "translateY(-50%)",
                                                //     zIndex: 1000
                                                // }}
                                                />
                                            }
                                            <MoreHorizSharpIcon className="material-symbols-sharp" onClick={(e) => handleMoreOptions(e, record)} />
                                        </div>
                                        <div className="message-bubble f-10 f-400">
                                            {record.msg}
                                            <div className="message-time">
                                                {moment.utc(record.time).local().format("LT")}
                                                <span className="message-status">
                                                    {record?.isRead === false ? (
                                                        <DoneAllSharpIcon className="material-symbols-sharp" style={{ width: '15px' }} />
                                                    ) : (
                                                        <DoneAllSharpIcon className="material-symbols-sharp text-read" style={{ width: '15px' }} />
                                                    )}
                                                </span>
                                            </div>
                                        </div>
                                        <img
                                            src={currentUserProfilPic}
                                            alt="Profile"
                                            className="message-avatar"
                                        />
                                    </>
                                )}
                            </div>
                            </React.Fragment>
                        )})}
                    </div>
                )
            }
            {user.isOpen && (
                <div className="chat-input">
                    <img
                        src={currentUserProfilPic}
                        alt="user Image"
                        width={30}
                        height={30}
                        style={{ borderRadius: "50px" }}
                    />
                    <textarea
                        type="text"
                        rows={1}
                        value={user.inputValue}
                        onChange={(e) => inputChangeHandler(user.userUid, e.target.value)}
                        placeholder={t("Newsfeed.Write messages down here")}
                        // onKeyPress={(e) => e.key === "Enter" && sendMessageHandler()}
                        onKeyDown={(e) => e.key === "Enter" && !e.shiftKey && (e.preventDefault(), sendMessageHandler())}
                    />
                      <AddReactionSharpIcon
                                            className="material-symbols-sharp me-2"
                                            onClick={handleEmojiClick}
                                            style={{ cursor: "pointer" }}
                                          />
                    <SendSharpIcon
                        // className="send-btn"
                        className='material-symbols-sharp'
                        onClick={() => sendMessageHandler()}
                        style={{ cursor: "pointer" }}
                    />
                </div>
            )}
             {showEmojiPicker && (
                        <div className="messageEmoji">
                          <ThemedEmojiPicker
                            onEmojiClick={(e, emojiObject) => { 
                            //   setContent(content + e.emoji);
                            updateInput(user.userUid, user.inputValue + e.emoji);
                              setShowEmojiPicker(false);
                            }}
                          />
                          <div
                            className="emoji-close"
                            onClick={handleEmojiClose}
                            style={{ cursor: "pointer" }}
                          >
                            <CloseSharpIcon className="material-symbols-sharp" />
                          </div>
                        </div>
                      )}
        </div>
    );
};

export default ChatBox;


/* ------------------------
-----------------------------------------------
Issue present in code base of outerChatBox.jsx
-----------------------------------------------
1. Input is send as empty to initial Api. (done)
2. Need to check for multiple user issue once message is send then it also show in other chat window(done)
3. Need to check with GetMessageList api as it is send only one record.(done)
4. CSS Responseness and dark and light theme(done).
5. Need to hide the chatbox when user sign out (done).
6. The message are not sending on second click chatbox (done).
7. Need to hide the chatbox on messaging screen (done).
*/